import * as React from "react";

import { cn } from "../../lib/utils";
import { type VariantProps, cva } from "class-variance-authority";

type TextareaStatus = "warning";

const textareaVariants = cva(
  "flex field-sizing-content min-h-16 w-full rounded-md border px-3 py-2 text-base shadow-xs transition-[color,box-shadow,background-color,border-color] outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:text-destructive not-read-only:aria-invalid:focus-visible:border-destructive not-read-only:aria-invalid:focus-visible:ring-[3px] not-read-only:aria-invalid:focus-visible:ring-destructive/20 not-read-only:aria-invalid:data-[focus=true]:border-destructive not-read-only:aria-invalid:data-[focus=true]:ring-destructive/20 not-read-only:data-[hover=true]:border-ring aria-invalid:not-read-only:data-[hover=true]:border-destructive data-[status=warning]:border-warning data-[status=warning]:text-warning not-read-only:data-[status=warning]:focus-visible:border-warning not-read-only:data-[status=warning]:focus-visible:ring-[3px] not-read-only:data-[status=warning]:focus-visible:ring-warning/40 not-read-only:data-[status=warning]:data-[focus=true]:border-warning not-read-only:data-[status=warning]:data-[focus=true]:ring-[3px] not-read-only:data-[status=warning]:data-[focus=true]:ring-warning/40 data-[status=warning]:not-read-only:data-[hover=true]:border-warning aria-invalid:data-[status=warning]:border-destructive aria-invalid:data-[status=warning]:text-destructive not-read-only:aria-invalid:data-[status=warning]:focus-visible:border-destructive not-read-only:aria-invalid:data-[status=warning]:focus-visible:ring-destructive/20 not-read-only:aria-invalid:data-[status=warning]:data-[focus=true]:border-destructive not-read-only:aria-invalid:data-[status=warning]:data-[focus=true]:ring-destructive/20 aria-invalid:data-[status=warning]:not-read-only:data-[hover=true]:border-destructive md:text-sm dark:aria-invalid:ring-destructive/40 not-read-only:dark:aria-invalid:data-[focus=true]:ring-destructive/40",
  {
    variants: {
      variant: {
        default:
          "border-border bg-transparent not-read-only:data-[focus=true]:border-control-focus not-read-only:data-[focus=true]:ring-0 not-read-only:focus-visible:border-control-focus not-read-only:focus-visible:ring-0 dark:bg-input/30 dark:enabled:[&[readonly]]:bg-transparent",
        ghost:
          "border-transparent bg-transparent not-read-only:data-[focus=true]:border-primary not-read-only:data-[focus=true]:ring-[3px] not-read-only:data-[focus=true]:ring-ring shadow-none not-read-only:hover:bg-accent not-read-only:hover:text-accent-foreground not-read-only:focus-visible:border-primary not-read-only:focus-visible:bg-background not-read-only:focus-visible:ring-[3px] not-read-only:focus-visible:ring-ring not-read-only:data-[hover=true]:bg-accent not-read-only:data-[hover=true]:text-accent-foreground not-read-only:data-[focus=true]:bg-background read-only:ring-0!",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

type TextareaProps = React.ComponentProps<"textarea"> &
  VariantProps<typeof textareaVariants> & {
    status?: TextareaStatus;
  };

function Textarea({
  className,
  status,
  variant,
  readOnly,
  placeholder,
  ...props
}: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      data-status={status}
      className={cn(textareaVariants({ variant }), className)}
      {...props}
      readOnly={readOnly}
      placeholder={readOnly ? undefined : placeholder}
    />
  );
}

export { Textarea };
export type { TextareaProps, TextareaStatus };
